import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { QuickNumbers } from '../Component/Dashboard/QuickNumbers';
import { LastComments } from '../Component/Dashboard/LastComments';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Company_Profile } from '../Redux/Actions/Company_Profile_Action';
import { QuickNumbersForMarketer } from '../Component/Dashboard/QuickNumbersForMarketer';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

// const EXPANDED_WIDTH  = 242;
// const COLLAPSED_WIDTH = 64;

export const Dashboardpage = () => {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const theme     = useTheme();
  const mode      = theme.palette.mode;
  const isMobile  = useMediaQuery(theme.breakpoints.down('md'));

  const [userlogin,     setuserlogin]     = useState('');
  // const [sidebarWidth,  setSidebarWidth]  = useState(EXPANDED_WIDTH);
const sidebarWidth = useSidebarWidth();
  /* ── listen for sidebar toggle ── */
  // useEffect(() => {
  //   const handler = (e) => setSidebarWidth(e.detail?.width ?? EXPANDED_WIDTH);
  //   window.addEventListener('sidebarResized', handler);
  //   return () => window.removeEventListener('sidebarResized', handler);
  // }, []);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setuserlogin(JSON.parse(u));
  }, []);

  const refreshleads = () => {
    localStorage.removeItem('stagestorage');
    userlogin?.data?.role === 'Admin'
      ? navigate('/AllLeadsForAdmin')
      : navigate('/ALLLeadsForMarketer');
  };

  useEffect(() => {
    dispatch(Get_All_Company_Profile());
  }, [dispatch]);

  const resgetall        = useSelector((s) => s.AllCompanyProfile.CompanyProfile);
  const AllCompanyprofile = Array.isArray(resgetall?.data) ? resgetall.data : [];
  const profile          = AllCompanyprofile[0];

  /* ── layout ── */
  const ml = isMobile ? 0 : sidebarWidth;

  return (
    <div
      style={{
        marginLeft      : ml,
        transition      : 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)',
        minHeight       : '100vh',
        backgroundColor : mode === 'dark' ? '#121212' : '#F7F8FC',
        padding         : isMobile ? '16px' : '32px 32px 80px',
        boxSizing       : 'border-box',
      }}
    >
      {/* breadcrumb */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 20,marginTop:40 }}>
        <span
          onClick={refreshleads}
          style={{ fontWeight: 600, cursor: 'pointer', color: '#1A3ECF', fontSize: 13 }}
        >
          Leads
        </span>
        <KeyboardDoubleArrowRightIcon style={{ fontSize: 16, color: '#7B829A' }} />
        <span style={{ color: '#7B829A', fontSize: 13 }}>Dashboard</span>
      </div>

      {/* greeting */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{
          margin       : 0,
          fontSize     : 22,
          fontWeight   : 700,
          color        : mode === 'dark' ? '#fff' : '#1C2340',
          fontFamily   : "'DM Sans', sans-serif",
        }}>
          Hello {userlogin?.data?.name} 👋
        </h1>
        <p style={{ margin: '4px 0 0', color: '#7B829A', fontSize: 13 }}>
          {profile?.description || 'Welcome to your CRM Dashboard'}
        </p>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid #E8EAF0', marginBottom: 28 }} />

      {/* quick numbers */}
      {userlogin?.data?.role === 'Admin'    && <QuickNumbers />}
      {userlogin?.data?.role === 'Marketer' && <QuickNumbersForMarketer />}

      {/* comments / analysis */}
      {userlogin?.data?.role === 'Admin' && <LastComments />}
    </div>
  );
};
